import React from 'react';

export const QuickFormContext = React.createContext();
